import { nearestSixteenth } from '../../../helpers';
import { Panel } from '../panel.class';

export type GetVentAlignedPassthroughXParams = {
	panel: Panel;
	alignRight: boolean;
	halfPassthroughWidth: number;
};

// Aligns an auto-added passthrough edge to the existing vent's edge so their edge-to-panel
// dimensions coincide (mirrors the corners + group-center span math in get-horizontal-intersection-areas.cfn).
export const getVentAlignedPassthroughX = (params: GetVentAlignedPassthroughXParams): number | null => {
	const { panel, alignRight, halfPassthroughWidth } = params;

	const ventItem = panel.panelItemGroups.children
		.flatMap((group) => group.items.children)
		.find((panelItem) => panelItem.item.category?.isVent) ?? null;

	if (ventItem === null) return null;

	const { front: corners } = ventItem.getCorners();
	const groupCenterX = ventItem.refMap?.panelItemGroup?.center.x ?? 0;
	const ventLeft = nearestSixteenth(corners[0].x + groupCenterX);
	const ventRight = nearestSixteenth(corners[1].x + groupCenterX);

	return alignRight ? ventRight - halfPassthroughWidth : ventLeft + halfPassthroughWidth;
};
